import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { AudioManager } from "../../AudioManager";
import { SplashScene } from "./SplashScene";

export class NewCardContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT - 40 * GameVars.scaleY;

        this.scaleX = .97;
        this.scaleY = GameVars.scaleY * .97;

        const label = new Phaser.GameObjects.Text (this.scene, -350, -18, text.NEW_CARD[lan], { fontFamily: "AlmendraBold", fontSize: "30px", color: "#000000" });
        label.setShadow(0, 4, "#7e4031", 0, false, true);
        label.setStroke("#3f2620", 6);

        if (label.width > 225) {
            label.setScale(225 / label.width);
        }
       
        const gradient = label.context.createLinearGradient(0, 0, 0, label.height);
        gradient.addColorStop(0, "#fffea8");
        gradient.addColorStop(0.5, "#feec57");
        gradient.addColorStop(1, "#ef8548");
        label.setFill(gradient);

        // ENCONTRAR EL PRECIO DE LA ÚLTIMA CARTA DESBLOQUEADA
        const specialCards = GameVars.gameData.specialCards;

        let lastUnlockedCardIndex = 0;

        for (let i = 0; i < specialCards.length; i++) {

            if (!specialCards[i].unlocked) {
                lastUnlockedCardIndex = i;
                break;
            }
        }
 
        const playButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "new_card_background");

        const playButton = new ButtonWithText(this.scene, playButtonImage, label, this.onClickShop, this);
        this.add(playButton);    
        
        const px = -110;
        const py = -12;
        const w = 470;
        const h = 28;
        const r = 8;

        const backgroundBar = new Phaser.GameObjects.Graphics(this.scene);
        backgroundBar.fillStyle(0x8a5432);
        backgroundBar.lineStyle(4, 0x552923); // Establece el estilo de línea para el borde: 2 px de ancho, color blanco
        backgroundBar.strokeRoundedRect(px, py, w, h, r); // Dibuja el borde del rectángulo redondeado
        backgroundBar.fillRoundedRect(px, py, w, h, r); // Dibuja el rectángulo redondeado
        playButton.add(backgroundBar);

        const scaleProgressBar = GameVars.gameData.gold / specialCards[lastUnlockedCardIndex].price < 1 ? GameVars.gameData.gold / specialCards[lastUnlockedCardIndex].price * 461 : 461;

        const progressBarLeftTip = new Phaser.GameObjects.Image(this.scene, px, py + 14, "texture_atlas_1", "corner_yellow");
        playButton.add(progressBarLeftTip);

        const progressBar = new Phaser.GameObjects.Image(this.scene, progressBarLeftTip.x + progressBarLeftTip.width / 2, progressBarLeftTip.y, "texture_atlas_1", "fill_bar_yellow");
        progressBar.setOrigin(0, .5);
        progressBar.scaleX = scaleProgressBar;
        playButton.add(progressBar);

        if (GameVars.gameData.gold / specialCards[lastUnlockedCardIndex].price >= 1 ) {
            const progressBarRighttTip = new Phaser.GameObjects.Image(this.scene, progressBarLeftTip.x + progressBarLeftTip.width + scaleProgressBar, py + 14, "texture_atlas_1", "corner_yellow");
            progressBarRighttTip.setOrigin(0, .5);
            progressBarRighttTip.scaleX = -1;
            playButton.add(progressBarRighttTip);
        }

        const availableGoldLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, GameVars.formatNumber(GameVars.gameData.gold), { fontFamily: "AlmendraBold", fontSize: "32px", color: "#663227"});
        availableGoldLabel.setOrigin(0, .5);
        playButton.add(availableGoldLabel);
       
        if (lastUnlockedCardIndex !== 0) {

            const nextCardPriceStr = "/" + GameVars.formatNumber(specialCards[lastUnlockedCardIndex].price);

            const nextCardPriceLabel = new Phaser.GameObjects.Text(this.scene, availableGoldLabel.x + availableGoldLabel.width + 5, 0, nextCardPriceStr, { fontFamily: "AlmendraBold", fontSize: "26px", color: "#663227"});
            nextCardPriceLabel.setOrigin(0, .5);
            playButton.add(nextCardPriceLabel);
    
            const coinIcon = new Phaser.GameObjects.Image(this.scene, nextCardPriceLabel.x + nextCardPriceLabel.width + 20, 2, "texture_atlas_1", "coin");
            coinIcon.setScale(.75);
            playButton.add(coinIcon);

        } else {

            availableGoldLabel.setOrigin(.5);
        }
    }

    private onClickShop(): void {

        if (SplashScene.currentInstance.settingsLayer) {
            return;
        }

        GameManager.enterShopScene();

        AudioManager.playSound("btn_click");
    }
}
